import * as React from 'react';
import isNewMailToastEnabled from '../selectors/isNewMailToastEnabled';
import isNewMailSoundEnabled from '../selectors/isNewMailSoundEnabled';
import isReminderToastEnabled from '../selectors/isReminderToastEnabled';
import isReminderSoundEnabled from '../selectors/isReminderSoundEnabled';
import setNewMailToastEnabled from '../mutators/setNewMailToastEnabled';
import setNewMailSoundEnabled from '../mutators/setNewMailSoundEnabled';
import setReminderToastEnabled from '../mutators/setReminderToastEnabled';
import setReminderSoundEnabled from '../mutators/setReminderSoundEnabled';
import { observer } from 'mobx-react';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';

export default observer(function AppNotificationsOptionFull() {
    return (
        <div>
            <OptionDescription>{strings.option_mail_NotifyTitle}</OptionDescription>
            <OptionsCheckbox
                checked={isNewMailToastEnabled()}
                onChange={onNewMailToastCheckboxClicked}
                label={strings.option_mail_NotifyToast}
            />
            <OptionsCheckbox
                checked={isNewMailSoundEnabled()}
                onChange={onNewMailSoundCheckboxClicked}
                label={strings.option_mail_NotifySound}
            />
            <OptionsCheckbox
                checked={isReminderToastEnabled()}
                onChange={onReminderToastCheckboxClicked}
                label={strings.option_reminder_NotifyToast}
            />
            <OptionsCheckbox
                checked={isReminderSoundEnabled()}
                onChange={onReminderSoundCheckboxClicked}
                label={strings.option_reminder_NotifySound}
            />
        </div>
    );
});

const onNewMailToastCheckboxClicked = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean
) => setNewMailToastEnabled(checked);

const onNewMailSoundCheckboxClicked = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean
) => setNewMailSoundEnabled(checked);

const onReminderToastCheckboxClicked = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean
) => setReminderToastEnabled(checked);

const onReminderSoundCheckboxClicked = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean
) => setReminderSoundEnabled(checked);
